export const NOT_AUTHORIZED_GA_USER = { type: 'not_authorized' };
